import { render, staticRenderFns } from "./FeaturedTalks.vue?vue&type=template&id=076e490a&scoped=true&"
import script from "./FeaturedTalks.vue?vue&type=script&lang=js&"
export * from "./FeaturedTalks.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedTalks.vue?vue&type=style&index=0&id=076e490a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076e490a",
  null
  
)

export default component.exports